(() => {
  let queue = Promise.resolve();
  const serial = task => { queue = queue.catch(() => {}).then(task); return queue; };
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root + path, body === undefined ? {headers:{Accept:'application/json'}} : {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings.error);
    return result;
  };
  const quantity = (cart, predicate) => cart.items.filter(predicate).reduce((total,item) => total + item.quantity, 0);
  class TheniyaGiftPicker extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code;
      this.productId = Number(this.dataset.productId);
      this.qualifiers = (this.dataset.qualifiers || '').split(',').map(Number);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gift-variant]');
        if (!button || button.disabled) return;
        serial(() => this.addGift(button));
      });
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source === 'theniya-gifts') return;
        serial(() => this.reconcile()).catch(error => this.showError(error));
      });
      const end = Date.parse(this.dataset.end);
      if (Number.isFinite(end) && end > Date.now()) this.expiryTimer = setTimeout(() => serial(() => this.reconcile()).catch(error => this.showError(error)), Math.min(end-Date.now()+100,2147483647));
      serial(() => this.reconcile()).catch(error => this.showError(error));
    }
    disconnectedCallback() { this.unsubscribe?.(); clearTimeout(this.expiryTimer); }
    active() {
      const start = Date.parse(this.dataset.start);
      const end = Date.parse(this.dataset.end);
      return this.dataset.active === 'true' && (!Number.isFinite(start) || Date.now() >= start) && (!Number.isFinite(end) || Date.now() < end);
    }
    allowance(cart) {
      if (!this.active()) return 0;
      const eligible = cart.items.filter(item => this.qualifiers.includes(item.product_id));
      const spend = eligible.reduce((total,item) => total + item.original_line_price,0);
      const count = eligible.reduce((total,item) => total + item.quantity,0);
      if (spend < Number(this.dataset.minimum)) return 0;
      return this.dataset.rule === 'order' ? (count ? Number(this.dataset.get) : 0) : Math.floor(count / Number(this.dataset.buy)) * Number(this.dataset.get);
    }
    codes(cart) { return (cart.discount_codes || []).map(code => code.code).filter(Boolean); }
    showError(error) {
      const picker = document.querySelector('theniya-gift-picker');
      const target = picker?.querySelector('[data-gift-error]');
      if (target) target.textContent = error.message || picker.querySelector('[data-gift-error-message]').textContent;
    }
    async render(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      const sections = drawer.getSectionsToRender().map(section => section.id);
      const state = await request('cart/update.js',{sections,sections_url:location.pathname});
      drawer.classList.toggle('is-empty',state.item_count === 0);
      drawer.renderContents(state);
      publish(PUB_SUB_EVENTS.cartUpdate,{source:'theniya-gifts',cartData:state});
    }
    async reconcile() {
      if (!this.isConnected) return;
      const cart = await request('cart.js');
      let allowed = this.allowance(cart);
      this.hidden = !this.active() || allowed === 0;
      const paid = quantity(cart,item => item.product_id === this.productId && item.properties?._theniya_gift !== this.code);
      allowed = Math.max(0, allowed-paid);
      let changed = false;
      for (const item of cart.items.filter(item => item.product_id === this.productId && item.properties?._theniya_gift === this.code)) {
        const keep = Math.min(item.quantity,allowed);
        allowed -= keep;
        if (keep !== item.quantity) { await request('cart/change.js',{id:item.key,quantity:keep}); changed=true; }
      }
      if (changed) await this.render(cart);
    }
    async addGift(button) {
      if (!this.isConnected) return;
      const errorText = this.querySelector('[data-gift-error-message]').textContent;
      const errorBox = this.querySelector('[data-gift-error]');
      errorBox.textContent = '';
      this.querySelectorAll('button').forEach(item => item.disabled=true);
      this.setAttribute('aria-busy','true');
      const variantId = Number(button.dataset.giftVariant);
      let before, added = false;
      try {
        before = await request('cart.js');
        if (!this.active()) throw new Error(this.querySelector('[data-gift-expired-message]').textContent);
        if (quantity(before,item => item.product_id === this.productId) >= this.allowance(before)) { await this.render(before); return; }
        await request('cart/add.js',{items:[{id:variantId,quantity:1,properties:{_theniya_gift:this.code}}]});
        added=true;
        const codes = [...new Set([...this.codes(before),this.code])];
        const after = await request('cart/update.js',{discount:codes.join(',')});
        const valid = (after.discount_codes || []).some(code => code.code.toUpperCase() === this.code.toUpperCase() && code.applicable);
        if (!valid) throw new Error(errorText);
        await this.render(after);
      } catch(error) {
        if (added && before) {
          const cart = await request('cart.js');
          const oldQuantity = quantity(before,item => item.variant_id === variantId && item.properties?._theniya_gift === this.code);
          const line = cart.items.find(item => item.variant_id === variantId && item.properties?._theniya_gift === this.code);
          if (line) await request('cart/change.js',{id:line.key,quantity:oldQuantity});
          await request('cart/update.js',{discount:this.codes(before).join(',')});
          await this.render(before);
        }
        this.showError(error);
      } finally {
        this.removeAttribute('aria-busy');
        if (this.isConnected) {
          const cart = await request('cart.js');
          if (quantity(cart,item => item.product_id === this.productId) < this.allowance(cart)) this.querySelectorAll('button[data-gift-variant]').forEach(item => { if (item.dataset.available === 'true') item.disabled=false; });
        }
      }
    }
  }
  customElements.define('theniya-gift-picker',TheniyaGiftPicker);
})();
